import { ReactTooltip } from 'src/v2/commonComponents/ReactTooltip/ReactTooltip';
import styles from './PlanCardMaxPromoTooltip.module.scss';
import { MAX_PROMO_TOOLTIP_ID, SUPER_PROJECT_NAME } from 'src/constants';

interface PlanCardMaxPromoTooltipProps {
  isOpen: boolean;
}

export const PlanCardMaxPromoTooltip = ({
  isOpen,
}: PlanCardMaxPromoTooltipProps) => {
  return (
    <ReactTooltip
      id={MAX_PROMO_TOOLTIP_ID}
      isOpen={isOpen}
      className={styles.root}
      place="top-start"
    >
      <span className={styles.title}>
        Want more {SUPER_PROJECT_NAME} tasks?
      </span>
    </ReactTooltip>
  );
};
